import axios from 'axios';
import fileDownload from 'js-file-download';
import config from '../utils/config';

const downloadAckApi = async (id) => {
  const accessToken = await window.localStorage.getItem('access_token');
  const response = await axios.request({
    url: `${config.serverBasePath}/api/v2/generate_acknowledgement?case_id=${id}&response_type=download`,
    method: 'GET',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/pdf',
      Accept: 'application/pdf',
      withCredentials: true,
      Authorization: `Bearer ${accessToken}`,
      'Access-Control-Allow-Origin': '*'
    },
  });
  return fileDownload(response.data, `${id}.pdf`);
};

export default downloadAckApi;
